import React from 'react'
import withView from '../../../../cmn/docAutomation/withView';
import FormDialog from '../../../../../library/form/components/FormDialog';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import ProdIOTRetCMNEditor from './ProdIOTRetCMNEditor';
import {CmnStoneSearch} from '../../../../cmn/snippet/Index';
import { UiGridColOne,UiCol } from "../../../../../library/layout/Index";

const ProdIOTRetStoneEditor = (props) => {
    const { formObject, viewData, masterKeys, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ refreshMode:"dep", actionParam:{actionType: 'addTaskRetItem', pathKey:"TRET", viewKey:"optReturn"},formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '250px' }}
            formStyle={{ width: '550px', height:"400px" }} formTitle={<SarasTrans value="Stone Editor" />}
        >
            <UiGridColOne>
                <UiCol>
                    <ul>
                        <li>
                            <CmnStoneSearch formObject={formObject} rowKey="" viewData={viewData} masterKeys={masterKeys} {...restProps} />
                        </li>
                        <ProdIOTRetCMNEditor {...props} />
                    </ul>
                </UiCol>
            </UiGridColOne>
        </FormDialog>
    )
}

export default withView(ProdIOTRetStoneEditor, "prodIOPlan", "prodIOPlan,prodIOSum,prodIOTRetOP")